import React from 'react';
import { Tab, styled } from '@mui/material';
import { palette } from '../../../theme';

interface COETabProps {
  label: string;
  value: string;
  variant?: 'default' | 'segmented';
}

const stripVariant = ({ variant, ...rest }: COETabProps) => {
  void variant;
  return rest;
};

const DefaultCOETab = styled((props: COETabProps) => <Tab {...stripVariant(props)} />)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(15),
  marginRight: theme.spacing(0.5),
  minHeight: 0,
  paddingTop: 6,
  paddingBottom: 6,
  paddingLeft: 18,
  paddingRight: 18,
  borderRadius: 20,
  color: palette.text.secondary,
  transition: 'background-color 0.2s, color 0.2s',
  '&.Mui-selected': {
    backgroundColor: palette.primary.main,
    color: palette.primary.contrastText,
  },
  '&:hover:not(.Mui-selected)': {
    backgroundColor: palette.action.hover,
    color: palette.text.primary,
  },
  '&.Mui-focusVisible': {
    backgroundColor: palette.action.focus,
  },
}));

const SegmentedCOETab = styled((props: COETabProps) => <Tab {...stripVariant(props)} disableRipple />)({
  textTransform: 'none',
  fontWeight: 500,
  fontSize: 13,
  marginRight: 0,
  minHeight: 0,
  minWidth: 0,
  padding: '7px 18px',
  borderRadius: 8,
  color: '#6B7084',
  flexShrink: 0,
  whiteSpace: 'nowrap',
  transition: 'all 0.15s',
  '&.Mui-selected': {
    backgroundColor: '#fff',
    color: '#1C1C1E',
    fontWeight: 600,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  '&:hover:not(.Mui-selected)': {
    color: '#1C1C1E',
    backgroundColor: 'transparent',
  },
});

const COETabComponent: React.FC<COETabProps> = (props) => {
  if (props.variant === 'segmented') {
    return <SegmentedCOETab {...props} />;
  }
  return <DefaultCOETab {...props} />;
};

export default COETabComponent;
